// API Configuration
// export const BASEURL = "http://localhost:5000/api";
export const BASEURL = process.env.REACT_APP_API_URL || "https://dashboard.nephrocorenexus.com/api";

// API Endpoints
export const API_ENDPOINTS = {
  DOCTOR_APPLICATIONS: "/doctor-applications",
  // ==================== AUTH ====================
  REGISTER: "/users/register",
  LOGIN: "/users/login",
  LOGOUT: "/users/logout",

  // ==================== USERS ====================
  USERS: "/users",
  USER_ME: "/users/me",
  USER_PROFILE_IMAGE: "/users/me/profile-image",
  DOCTORS: "/users/doctors",
  ADMIN_CREATE_USER: "/users/admin/create",
  USERS_LIST: "/users",
  //points setting

  POINTS_SETTINGS: "/setting",
  // ==================== APPOINTMENTS ====================
  APPOINTMENTS: "/appointments",
  APPOINTMENT_CANCEL: (id) => `/appointments/${id}/cancel`,

  // ==================== LABS ====================
  LABS: "/labs",
  LAB_LOGO: (id) => `/labs/${id}/logo`,
  LAB_LOCATIONS: (id) => `/labs/${id}/locations`,

  // ==================== LAB TESTS ====================
  LAB_TESTS: "/lab-tests",
  LAB_TEST_CATEGORIES: "/lab-tests/categories/all",
  LAB_TEST_BY_CATEGORY: (category) => `/lab-tests/category/${category}`,
  LAB_TEST_PRICING: (id) => `/lab-tests/${id}/pricing`,

  // ==================== TEST BOOKINGS ====================
  TEST_BOOKINGS: "/test-bookings",
  TEST_BOOKING_STATUS: (id) => `/test-bookings/${id}/status`,
  TEST_BOOKING_REPORT: (id) => `/test-bookings/${id}/report`,
  TEST_BOOKING_PRESCRIPTION: (id) => `/test-bookings/${id}/prescription`,

  // ==================== UPLOAD ====================
  UPLOAD_SINGLE: "/upload/single",
  UPLOAD_MULTIPLE: "/upload/multiple",
  UPLOAD_DELETE: "/upload",

  // ==================== REPORTS ====================
  REPORTS_DASHBOARD: "/reports/dashboard-stats",
  REPORTS_APPOINTMENTS: "/reports/appointments",
  REPORTS_LAB_TESTS: "/reports/lab-tests",
  REPORTS_REVENUE: "/reports/revenue",
  REPORTS_USER_GROWTH: "/reports/user-growth",

  // ==================== NOTIFICATIONS ====================
  NOTIFICATIONS: "/notifications",
  NOTIFICATIONS_UNREAD_COUNT: "/notifications/unread-count",
  NOTIFICATIONS_MARK_ALL_READ: "/notifications/mark-all-read",

  // ==================== SETTINGS ====================
  SETTINGS_SYSTEM: "/settings/system",
  SETTINGS_EMAIL: "/settings/email",
  SETTINGS_PAYMENT: "/settings/payment",

  //doctors
  DOCTORDETAILS: "/doctorsdetails",
  DASHBOARD: "/dashboard",

  // ==================== PATIENTS ====================
  PATIENTS: "/patients",

  // ==================== MEMBERSHIP ====================
  MEMBERSHIP_PLANS: "/membership/plans",
  MEMBERSHIP_ADMIN_PLANS: "/membership/admin/plans",
  MEMBERSHIP_PLAN_BY_ID: (id) => `/membership/plans/${id}`,
};

const config = {
  BASEURL,
  API_ENDPOINTS,
};

export default config;
